import { usePaymentFormPage } from '../../../../graphql/hooks/form-page'
import { PaymentIntentStage } from '../../../../lib/store/p2p/PaymentIntentStage'
import type { PageWithContext } from '../../../../lib/utils/context'
import { PAGE_OPTIONS } from '../../../../lib/utils/page'
import { getProfilePaymentLayout } from '../../../../page-templates/profile-payment-page'
import type { ProfilePaymentPageProps } from '../../../../server/helpers/profile'

const Pay: PageWithContext<ProfilePaymentPageProps> = () => {
    // prefetch the pay by card page
    usePaymentFormPage({ stage: PaymentIntentStage.Input })
    return null
}

Pay.getLayout = getProfilePaymentLayout(PAGE_OPTIONS.PROFILE_PAY)

export default Pay

export { getServerSideProps } from '../../../../server/helpers/profile'
